import React, { useState, useEffect } from "react";
import "./cryptoSubscriptionSection.css";
import { Button } from "../../../components";
import {
  ArrowLeftIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/outline";
import useCryptoSubscription from "../../../hooks/useCryptoSubscription";

function CryptoSubscriptionSection({
  selectedPlan,
  setPage,
  setPaymentInitiated,
  fetchPaymentStatus,
}) {
  const [selectedCrypto, setSelectedCrypto] = useState("");
  const [paymentProcessing, setPaymentProcessing] = useState(false);
  const { subscribeCrypto, loading, error, clearError } =
    useCryptoSubscription();

  const cryptoOptions = [
    {
      id: "btc",
      name: "Bitcoin",
      symbol: "BTC",
    },
    {
      id: "eth",
      name: "Ethereum",
      symbol: "ETH",
    },
    {
      id: "usdt",
      name: "Tether",
      symbol: "USDT",
    },
    {
      id: "usdc",
      name: "USD Coin",
      symbol: "USDC",
    },
  ];

  const handleCryptoSelect = (crypto) => {
    setSelectedCrypto(crypto);
  };

  const handlePayment = async () => {
    if (!selectedCrypto || paymentProcessing) return;

    setPaymentProcessing(true);
    clearError();

    const result = await subscribeCrypto(selectedPlan.id, selectedCrypto.id);

    if (result.success) {
      setTimeout(async () => {
        await fetchPaymentStatus();
        setTimeout(() => {
          setPaymentInitiated(true);
        }, 500);
      }, 500);
    } else {
      setPaymentProcessing(false);
    }
  };

  useEffect(() => {
    if (error) {
      const timeout = setTimeout(() => {
        clearError();
      }, 5000);

      return () => clearTimeout(timeout);
    }
  }, [error, clearError]);

  const handleBack = () => {
    setSelectedCrypto("");
    clearError();
    setPage("select-section");
  };

  return (
    <div className="orion__crypto-wrapper">
      <div className="orion__crypto-header">
        <button onClick={handleBack} className="orion__back-button">
          <ArrowLeftIcon className="orion__back-icon" />
        </button>
      </div>

      <div className="orion__plan-summary-detailed">
        <div className="orion__plan-info">
          <h4>Preço selecionado</h4>
          <div className="orion__plan-details">
            <div className="orion__plan-price">
              <span className="orion__amount">{selectedPlan.price}</span>
              <span className="orion__currency">{selectedPlan.currency}</span>
            </div>
            <div className="orion__plan-duration">
              <strong>{selectedPlan.duration_in_days} dias</strong> de acesso
              completo
            </div>
            <div className="orion__payment-method">
              Pagamento via Criptomoeda
            </div>
          </div>
        </div>
      </div>

      <div className="orion__crypto-selection">
        <h4>Escolha sua criptomoeda:</h4>
        <div className="orion__crypto-options">
          {cryptoOptions.map((crypto) => (
            <div className="orion__crypto-button" key={crypto.id}>
              <input
                type="radio"
                checked={selectedCrypto.id === crypto.id}
                onChange={() => handleCryptoSelect(crypto)}
                name="crypto"
                disabled={loading || paymentProcessing}
              />
              <div className="orion__crypto-details">
                <h5>{crypto.name}</h5>
                <small>{crypto.symbol}</small>
              </div>
            </div>
          ))}
        </div>
      </div>

      {error && (
        <div className="orion__warning">
          <ExclamationCircleIcon className="orion__warning-icon" />
          <small>{error} - Tente novamente</small>
        </div>
      )}

      <Button
        styleType="filled"
        onClick={handlePayment}
        text={loading || paymentProcessing ? "PROCESSANDO..." : "PAGAR"}
        disabled={!selectedCrypto || loading || paymentProcessing}
      />
    </div>
  );
}

export default CryptoSubscriptionSection;
